import { Box, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { currentContextAtom, userAtom } from '../../state';
import { PRIVACY_SETTING_WORDING } from './PrivacySettingSelect';

export default function EmailContactInformationDisplay(): React.JSX.Element {
  const user = useAtomValue(userAtom);
  const { realm } = useAtomValue(currentContextAtom);
  const { t } = useTranslation(['common', 'settings']);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
      }}
    >
      <Box
        sx={{
          width: {
            xs: '100%',
            sm: '50%',
          },
        }}
      >
        <ListItem>
          <ListItemText
            sx={{
              wordBreak: 'break-word',
              display: 'flex',
              flexDirection: 'column-reverse',
            }}
            primary={user.email}
            secondary={t('common:address')}
          />
        </ListItem>

      </Box>
      <Box sx={{ width: '50%' }}>
        <ListItem>
          <ListItemText
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse',
            }}
            primary={
              user.contactInformation?.emailPrivacySetting
                ? t(PRIVACY_SETTING_WORDING[user.contactInformation.emailPrivacySetting][realm]!)
                : '-'
            }
            secondary={t('settings:information_visible_to')}
          />
        </ListItem>
      </Box>
    </Box>
  );
}
